<template>
  <div class="h-full overflow-hidden">
    <tableButtonGroup class="mt-10px" v-model="activeTab" :list="tabList" @btn-click="tabClick" />
    <deviceList :player="player" @row-click="handleRowClick" v-if="activeTab === '设备列表'" />
    <abnormalDevice :player="player" @row-click="handleRowClick" v-if="activeTab === '异常设备'" />

    <div class="explosion-btn" v-if="currentItem" @click="handleExplosion">
      {{ isExplosion ? '模型恢复' : '模型拆解' }}
    </div>
  </div>
</template>

<script>
import tableButtonGroup from '@/components/cockpit/TableButtonGroup'
import deviceList from './deviceList'
import abnormalDevice from './abnormalDevice'

export default {
  name: 'deviceDiagnostics',
  components: {
    tableButtonGroup,
    deviceList,
    abnormalDevice
  },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activeTab: '设备列表',
      tabList: ['设备列表', '异常设备'],
      currentItem: 0,
      isExplosion: false, // 是否拆解
      currentRow: {},
    }
  },
  watch: {
    transferProps: {
      handler(val) {
        if (val && val.code) {
          this.handleRowClick(val)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    getKksCode() {
      return (kksCode) => {
        const prefix = kksCode.slice(0, 4)
        if (prefix === '6760') {
          return kksCode.slice(4, kksCode.length)
        }
        return kksCode
      }
    },
  },
  methods: {
    tabClick(tab) {
      this.activeTab = tab
    },
    // 模型拆解
    async handleExplosion() {
      if (this.isExplosion) {
        await this.handleRecovery()
        return
      }
      await this.player.Native.Explosion.beginExplosion(this.currentItem)
      await this.player.Native.Explosion.setExplosionExtent(1.5)
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(this.getKksCode(this.currentRow.code))
      if (codeInfo && codeInfo.item) {
        await this.player.Native.Camera.moveToItem(codeInfo.item, 0.1)
      }
      this.isExplosion = true
    },
    // 模型恢复
    async handleRecovery() {
      if (!this.isExplosion) {
        return
      }
      await this.player.Native.Explosion.endExplosion()
      this.isExplosion = false
    },
    async handleRowClick(row) {
      await this.handleRecovery()
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(this.getKksCode(row.code))
      if (codeInfo && codeInfo.item) {
        this.player.Native.Camera.moveToItem(codeInfo.item, 1)
        this.currentItem = codeInfo.item
      } else {
        this.currentItem = 0
      }
      this.currentRow = row
      await this.setRootModelShow(false)
      await this.setDisabledPanel(false, [row.code])
      if (codeInfo?.item) {
        this.player.Native.ModelTree.setItemVisible([codeInfo.item], true)
      }
      this.$emit('transferEvent', {
        toCom: { code: 'DeviceDiagnosticsDetail', origin: 'DeviceDiagnostics', name: '设备诊断信息' },
        type: 'mainComponent',
        props: {
          ...row
        },
      })
    },
    // 设置不展示面板
    async setDisabledPanel(showAll, codeList) {
      const openEvent = new CustomEvent('setDisabledPanel', {
        detail: {
          codeList: codeList || [],
          showAll,
        },
      })
      window.dispatchEvent(openEvent)
    },
    async setRootModelShow(show) {
      let root = await this.player.Native.ModelTree.getRootItems()
      root = root.filter((item) => { return item.itemType !== 2 })
      const rootList = root.map((val) => {
        return val.item
      })
      this.player.Native.ModelTree.setItemVisible(rootList, show)
    },
  },
  async beforeDestroy() {
    await this.setRootModelShow(true)
    await this.setDisabledPanel(true)
    await this.handleRecovery()
  },
}
</script>

<style lang="scss" scoped>
.explosion-btn {
  position: fixed;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 362px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(#113444, #097fa4);
  border-radius: 32px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  letter-spacing: 1px;
}
</style>
